(() => {
  const initialize = (scope = document) => {
    const components = scope.matches?.('[data-puff-reviews]') ? [scope] : scope.querySelectorAll('[data-puff-reviews]');
    components.forEach((component) => {
      if (component.dataset.reviewsInitialized === 'true') return;
      component.dataset.reviewsInitialized = 'true';
      component.querySelectorAll('[data-review-open]').forEach((link) => {
        link.addEventListener('click', (event) => {
          const details = component.querySelector('[data-review-details]');
          const title = component.querySelector('[data-review-form-title]');
          if (!details || !title) return;
          event.preventDefault();
          details.open = true;
          title.focus({ preventScroll: true });
          title.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        });
      });
      const dialog = component.querySelector('[data-review-photo-dialog]');
      const close = dialog?.querySelector('[data-review-photo-close]');
      const media = dialog?.querySelector('[data-review-photo-media]');
      const caption = dialog?.querySelector('[data-review-photo-caption]');
      if (!dialog || !close || !media || typeof dialog.showModal !== 'function') return;
      let returnFocus;
      component.querySelectorAll('[data-review-photo]').forEach((link) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          returnFocus = link;
          const image = new Image();
          image.alt = link.querySelector('img')?.alt || '';
          image.decoding = 'async';
          image.src = link.href;
          media.replaceChildren(image);
          if (caption) caption.textContent = link.dataset.reviewPhotoAuthor || '';
          dialog.showModal();
          close.focus({ preventScroll: true });
        });
      });
      close.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target !== dialog) return;
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => {
        media.replaceChildren();
        returnFocus?.focus({ preventScroll: true });
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
